import {register} from './../exports/theme-sections';
import parallaxImage from './../exports/parallaxImage';
import scrollButton from './../features/scroll-button';


register('hero', [parallaxImage, scrollButton]);
